import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class TemaService {
  private readonly chaveStorage = 'tema';

  // true = modo escuro, false = modo claro
  private modoEscuroSubject = new BehaviorSubject<boolean>(false);
  modoEscuro$ = this.modoEscuroSubject.asObservable();

  constructor() {
    //  tenta ler o tema salvo no localStorage
    const salvo = localStorage.getItem(this.chaveStorage);

    // se no localStorage estiver salvo "escuro", inicia no modo escuro. A comparação (salvo === 'escuro') retorna true ou false.
    const iniciarComoEscuro = salvo === 'escuro';

    // aplica o que veio do storage
    this.aplicarTema(iniciarComoEscuro);
  }

  alternarTema(): void {
    const novoValor = !this.modoEscuroSubject.value;
    this.aplicarTema(novoValor);
  }

  definirModoEscuro(ativo: boolean): void {
    this.aplicarTema(ativo);
  }

  /** retorna o valor atual */
  estaEscuro(): boolean {
    return this.modoEscuroSubject.value;
  }

  sincronizarComDOM(): void {
    const salvo = localStorage.getItem(this.chaveStorage);
    const deveEstarEscuro = salvo === 'escuro';
    this.aplicarTema(deveEstarEscuro);
  }

  /** aplica o tema no <html> */
  private aplicarTema(modoEscuro: boolean): void {
    this.modoEscuroSubject.next(modoEscuro);

    const raiz = document.documentElement;

    // Liga/desliga classe "dark" 
    raiz.classList.toggle('dark', modoEscuro);

    if (modoEscuro) {
      raiz.setAttribute('data-theme', 'violet');
    } else {
      raiz.removeAttribute('data-theme');
    }

    // salva o tema escolhido 
    localStorage.setItem(this.chaveStorage, modoEscuro ? 'escuro' : 'claro');
  }
}
